<template>
  <div >
    <div class="toph mb16" >
      <span>回款</span>
      <span style="display: flex; align-items: center">
        <Input style="width: 300px;" v-model="searchData.contractCode" placeholder="请输入合同号" @keyup.enter.native="inputChange"></Input>
        <label @click.stop="inputChange" style="display: flex; margin-left: 5px">
          <Icon type="ios-search" size="24" color="#CFA868"/>
        </label>
      </span>
    </div>

    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'个人回款'+' '+grNum" name="gr"></TabPane>
        <TabPane :label="'企业回款'+' '+qyNum" name="qy"></TabPane>
      </Tabs>

      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :defaultTem="isShow"
        :pageSize="5"
      >
      </table-list>
      <confirm-modal :n = "confirmKey" :action="`收取第${periods}期账单 `" :actionother="'线下收款对账时效为当前日期+1个工作日！'"  @cancel = "collection"></confirm-modal>
      <read-modal :n="readKey" :billId ="billId" :contractCode="contractCode"></read-modal>
      <update-modal :n="updateKey" :billId ="billId" :contractCode="contractCode" @refresh="findData"></update-modal>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import {getReceiveList, getReceiveNum } from 'api/accountsReceivable'
  import { canCertificate } from 'api/accountsReceivable'
  import {formatDateTime} from "@//utils/format"
  import ReadModal from "./components/ReadModal"
  import UpdateModal from "./components/UpdateModal"
  import ConfirmModal from 'components/CancelModal/index';

  export default {
    name: "Renew",
    components: {
      TableList,
      ReadModal,
      UpdateModal,
      ConfirmModal
    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.searchData.contractCode = ''
        this.page=1
        this.current=1
        this.getReceiveNum()
      },
      shortCut1(value) {
        switch (value) {
          case 'gr':
            this.clearValue()
            this.customerType = 1;
            break;
          case 'qy':
            this.clearValue()
            this.customerType = 3;
            break;
        }
        this.page=1
        this.current=1
        this.getpageList();
      }
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        recordCut:'',
        shortCut1: 'gr',
        page: 1,
        limit: 5,
        customerType:1,
        searchData: {
          contractCode:'',
        },
        readKey:0,
        updateKey:0,
        billId:0,
        contractCode:'',
        grNum:0,
        qyNum: 0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        isShow:false,
        billNumber:'',
        entCollectionKey:0,
        periods:1,
        confirmKey:0,
        columns:[
            {
              type: "index",
              key: "index",
              width: 60,
              align: "center"
            },
            {
              title:' ',
            },
            {
              title:'合同号',
              key:'contractCode',
              align:'center',
              width:220,
              render: (h, params) => {
                if (params.row['overCount'] && params.row['overCount']>0 ) {
                  const point=h('span',{
                    style:{
                      display:'inline-block',
                      backgroundColor:'#cfa868',
                      width:'5px',
                      height:'5px',
                      borderRadius:'5px',
                      position:'relative',
                      top:'-4px',
                      marginLeft:'2px'
                    },
                    attrs: {
                      title: '有'+params.row['overCount']+'次逾期'
                    },
                  },' ')

                  return h('Tooltip', {
                    props: {
                      placement: "top-end"
                    }
                  }, [
                    h('div', {
                      style: {
                        whiteSpace: 'normal'
                      },
                      slot: 'content',
                    }, '有'+params.row['overCount']+'次逾期'),
                    h('span',{},params.row['contractCode']),
                    point
                  ])
                }
                else {
                  return h('span',{},params.row['contractCode'])
                }
              }
            },
            {
              title:' ',
            },
            {
              title: '房间/床位号',
              key: 'roomCode',
              align: 'center',
              width:120
            },
          {
            title:' ',
          },
          {
            title: '剩余天数',
            key: 'overDate',
            align: 'center',
            width:120,
            render: (h,params) => {
              return h('div',{
                'class': {
                  'error-color': ((new Date(params.row['limitPayDate'])) - new Date(formatDateTime(new Date(), false)))/1000/60/60/24 <= 0
                },
              },(new Date(params.row['limitPayDate']) - new Date(formatDateTime(new Date(), false)))/1000/60/60/24)
            }
          },
          {
            title:' ',
          },{
            title: '逾期违约金',
            key: 'shouldDedit',
            align: 'center',
            width:120,
            render: (h,params) => {
              return h('div',{
                'class': {
                  'error-color': params.row.shouldDedit > 0
                },
              },params.row['shouldDedit'] > 0 ? params.row['shouldDedit'] : "")
            }
          },
            {
              title:' ',
            },
            {
              title: '客户名称',
              key: 'customerName',
              align: 'center',
              width:220
            },
            {
              title:' ',
            },
            {
              title: '应收金额',
              key: 'curSumAmount',
              align: 'center',
              width:120
            },
            {
              title:' ',
            },
            {
              title: '已核销金额',
              key: 'realSumAmount',
              align: 'center',
              width:100
            },
            {
              title:' ',
            },
            {
              title: '计划收款日期',
              key: 'limitPayDate',
              align: 'center',
              width:120
            },
            {
              title:' ',
            },{
              title: '最新跟进内容',
              key: 'lastCollectionDesc',
              align: 'center',
              width:150,
              render: (h, params) => {
                if (params.row['lastCollectionDesc'] && params.row['lastCollectionDesc'].length > 7) {
                  return h('Tooltip', {
                    props: {
                      placement: "top"
                    }
                  }, [
                    h('div', {
                      style: {
                        whiteSpace: 'normal'
                      },
                      slot: 'content',
                    }, params.row['lastCollectionDesc']),
                    h('span', {}, params.row['lastCollectionDesc'].slice(0, 7) + '...')
                  ])

                }
                else {
                  return h('span', {}, params.row['lastCollectionDesc'])
                }
              }
            },
            {
              title:' ',
            },{
              title: '最新跟进时间',
              key: 'lastCollectionTime',
              align: 'center',
              width:120,
              render: (h,params) => {
                return h('div',formatDateTime(params.row.lastCollectionTime, true).slice(0, 16))
              }
            },
            {
              title:' ',
            },{
              title:'操作',
              key:'action',
              align:'center',
              fixed:'right',
              width:150,
              render: (h,params) =>{
                return h('div',[h('a',{
                  style: {
                    display: (params.row.curPlanNum==1 || (params.row.customerType === 1 && !params.row.parentContractCode)) ? 'none':'inline-block',
                    marginRight: '5px',
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:['certificate/savePaymentVoucher','certificate/batchSaveCertificate']
                      }
                    }
                  ],
                  on:{
                    click: ()=>{
                      this.isCanCertificate(params)
                    }
                  }
                },'收款'),
                  h('a',{
                  style: {
                    marginRight: '5px',
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'certificate/getReceiveFollow'
                      }
                    }
                  ],
                  on:{
                    click: () => {
                      this.contractCode = params.row.contractCode
                      this.billId = params.row.billId
                      this.readKey++
                    }
                  }
                },'查看'),
                  h('a',{
                    style: {
                      marginRight: '5px',
                    },
                    directives:[
                      {
                        name:'p',
                        value:{
                          api:'certificate/saveReceiveFollow'
                        }
                      }
                    ],
                    on:{
                      click: () => {
                        this.contractCode = params.row.contractCode
                        this.billId = params.row.billId

                        if(this.shortCut1 === 'gr'){
                          this.recordCut = 'gr'
                        }else if(this.shortCut1 === 'qy'){
                          this.recordCut = 'qy'
                        }
                        this.updateKey++
                      }
                    }
                  },'跟进')
                ])
              }
            }
          ]
      }
    },
    methods: {
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      findData(){
        if (this.data.length === 1) {
          this.current=1
          this.page=1
        }
        this.getReceiveNum()
        this.$emit('refreshTotalNum')
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
          customerType:this.customerType,
          ...this.searchData
        }
        getReceiveList(params).then(res => {
          if(!res.data){
            return
          }
          this.data = res.data.rows
          if(this.data.length<=0 ) {
            this.isShow = true;
          }
          this.total = res.data.total
        }).catch(error=>{})
      },
      getReceiveNum() {
        if(!this.projectFid){
          return
        }

        const params={
          projectFid:this.projectFid,
          ...this.searchData
        }
        getReceiveNum(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach((ele)=>{
            if(ele.customerType == 1){
              this.grNum = ele.number
            }else if (ele.customerType == 3){
              this.qyNum = ele.number
            }
          })
          this.locationTab()
          this.getpageList()
        }).catch(error => {
        })
      },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      inputChange(){
        this.current=1
        this.page=1
        this.data=[]

        if(this.shortCut1 === 'gr'){
          this.recordCut = 'gr'
        }else if(this.shortCut1 === 'qy'){
          this.recordCut = 'qy'
        }

        this.getReceiveNum()
      },
      locationTab() {
        if(this.recordCut === 'gr'){
          this.shortCut1='gr'
          this.customerType = 1;
          return
        }else if(this.recordCut === 'qy'){
          this.shortCut1='qy'
          this.customerType = 3;
          return
        }

        if(this.grNum){
          this.shortCut1='gr'
          this.customerType = 1;
        }else if(this.qyNum){
          this.shortCut1='qy'
          this.customerType = 3;
        }else {
          this.shortCut1='gr'
          this.customerType = 1;
        }
      },
      initData(){
        this.getReceiveNum()
      },
      isCanCertificate(params){
        if(params.row.parentContractCode){
          this.entCollectionKey++
          this.$router.push({name: 'enterprisecollection',query:{isFirst:0,key:this.entCollectionKey,parentContractCode:params.row.parentContractCode,curPlanNum:params.row.curPlanNum}})
        }else{
          canCertificate({billNum:params.row.rentBillNum}).then(res => {
            this.billNumber = params.row.rentBillNum
            this.contractCode = params.row.contractCode
            if (params.row.curPlanNum){
              this.periods = params.row.curPlanNum
              this.confirmKey++
            }else {
              this.$router.push({
                name: 'collection',
                query:{
                  proId:this.projectFid,
                  bNum: params.row.rentBillNum,
                  cCode: params.row.contractCode
                }
              })
            }
          })
        }
      },
      collection(){
        this.$router.push({
          name: 'collection',
          query:{
            proId:this.projectFid,
            bNum:this.billNumber,
            cCode: this.contractCode
          }
        })
      }
    },
    created() {
      this.initData()
    }
  }
</script>

<style scoped>
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }


</style>
